import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="bg-[#1B0F07] px-4 py-5 text-center text-cream/60" data-id="element-73" data-mp="3gfiuujlrgden">
      <div className="mx-auto max-w-3xl space-y-1.5 text-[0.7rem] font-medium leading-snug" data-id="element-74" data-mp="32nuhkczrziw3">
        <p className="font-bold text-cream/80" data-id="element-75" data-mp="36pfu1x8edv5r">© 2026 {PRODUCT_NAME} — All Rights Reserved.</p>
        <p data-id="element-76" data-mp="3uf0p3ehtsive">
          This system provides educational information about cinnamon roll preparation and product development. Results
          and income are not guaranteed. Users remain responsible for complying with applicable food preparation,
          licensing, labeling, allergen, tax, business and sales requirements in their location.
        </p>
        <p className="text-cream/70" data-id="element-77" data-mp="3qc3yp1m1nigw">Terms &amp; Conditions • Privacy Policy • Contact</p>
        <p data-id="element-78" data-mp="29y5frxf8retf">
          Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-bold text-gold hover:underline" data-id="element-79" data-mp="2a19vns22jyzx">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}